async function apiFetch(path: string, requestInit: RequestInit = {}, additionalHeaders: [string, string][] = []): Promise<Response> {
    if (additionalHeaders.length > 0) {
        requestInit.headers = additionalHeaders;
    }
    requestInit.credentials = 'include';
    return fetch(`${import.meta.env.VITE_API_URL}${path}`, requestInit);
}

export { apiFetch };
